import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext.js";
import Loader from "./Loader";

const AdminRoute = () => {
  const { user, loading } = useAuth();

  if (loading) return <Loader />;

  return user?.isAdmin ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AdminRoute;
